"use client";

import { IconArrowRotateCounterClockwise } from "central-icons/IconArrowRotateCounterClockwise";
import { m } from "motion/react";
import { SPRING_SLOW, useMotionSafe } from "@/lib/motion";
import { cn } from "@/lib/utils";

export default function ReplayIcon({
  className,
  turns,
}: {
  className?: string;
  turns: number;
}) {
  const motionSafe = useMotionSafe();

  return (
    <m.span
      animate={motionSafe({ rotate: turns * -360 })}
      className="flex will-change-transform"
      transition={SPRING_SLOW}
    >
      <IconArrowRotateCounterClockwise className={cn("size-4", className)} />
    </m.span>
  );
}
